export class vlsfoCalculationService {
    ;
    static CalculateShipdetailsHfo(config1) {

        let Mainengine = config1;
        Mainengine.forEach((element) => {
            let MCR_KW = parseFloat(element.MCR_KW);
            element.MCR_HP = (MCR_KW * 1.34102).toFixed(2);
        })
        return Mainengine

    }
    static CalculateShipdetailsHfoAuxililaryengine(config) {
        //
        let Auxiliaryengine = config;
        Auxiliaryengine.forEach((element) => {
            let MCR_KW = parseFloat(element.MCR_KW);
            element.MCR_HP = (MCR_KW * 1.34102).toFixed(2);
        })
        return Auxiliaryengine
    }
    static Calculatevlsfo(config1, config2, config3, config4, config5) {
        //
        let mainengine = config1;
        let total = null;
        let me_fo_cons = null;
        let AE_Fo_consumption = null;
        let ME_Well_To_Wake_CO2_Emissions_Calculated = 0;
        let ME_CO2_Emissions_Calculated = 0;
        let ME_CO2_Emissions_CV_from_Seatrials = 0;
        let ME_Clean_hull_conditons = 0;
        let ME_CO2_Emissions_from_BDN = 0;
        let AE_Well_To_Wake_CO2_Emissions_Calculated = 0;
        let AE_CO2_Emissions_Calculated = 0;
        let AE_CO2_Emissions_CV_from_Seatrials = 0;
        let AE_Clean_hull_conditons = 0;
        let AE_CO2_Emissions_from_BDN = 0;

        let ME_FO_consumption_kg_h = 0;              //internal formula
        let ME_based_on_cv = 0;                     //internal formula
        let ME_based_fuel_in_use = 0;              //internal formula
        let ME_based_on_BDN = 0;                  //internal formula
        mainengine.forEach((ele, index) => {
            let Actual_Load_MCR = ((ele.actual_load / ele.mcr) * 100);
            ele.Actual_Load_MCR = Actual_Load_MCR.toFixed(2);
            let start = new Date(ele.start);
            let end = new Date(ele.end);
            total = ((end - start) / 36e5)
            ele.total = total.toFixed(2);//result
            let mc_ctr_start = parseFloat(ele.mc_ctr_start);
            let mc_ctr_end = parseFloat(ele.mc_ctr_end);
            me_fo_cons = (mc_ctr_end - mc_ctr_start);
            ele.me_fo_cons = me_fo_cons.toFixed(2);//result
            ME_FO_consumption_kg_h = (ele.mcr * ele.fO_Con_100) / 1000;///internal formula
            ME_based_on_cv = (((ele.actual_load * ele.fO_Con_100) / 1000000) * total).toFixed(2);  //internal formula
            ME_based_fuel_in_use = ((ele.Calorific_Value_from_Seatrails / ele.Actual_Calorific_Value) * ME_based_on_cv);  //internal formula
            ME_based_on_BDN = ((ele.Actual_Calorific_Value / ele.BDN) * ele.me_fo_cons).toFixed(2); ////internal formula
            let Well_To_Wake_co2_emission = 0;
            let CO2_Emissions_Calculated = 0;
            let CO2_Emissions_CV_from_Seatrials = 0;
            let Clean_hull_conditons = 0;
            let CO2_Emissions_from_BDN = 0;
            if (ele.fuel_use == 1) {
                let vlsfo = 3.188;
                let welltowake = 3.734;
                Well_To_Wake_co2_emission = (welltowake * ele.me_fo_cons)
                ele.Well_To_Wake_co2_emission = (Well_To_Wake_co2_emission).toFixed(2);
                CO2_Emissions_Calculated = (vlsfo * ele.me_fo_cons);
                ele.co2_emission = CO2_Emissions_Calculated.toFixed(2);    //--------1
                CO2_Emissions_CV_from_Seatrials = ((ele.me_fo_cons - ME_based_on_cv) * vlsfo);
                ele.co2_emission_seatrails = CO2_Emissions_CV_from_Seatrials.toFixed(2); //------2
                Clean_hull_conditons = ((ele.me_fo_cons - ME_based_fuel_in_use) * vlsfo);
                ele.Clean_hull_conditons = Clean_hull_conditons.toFixed(2); //---------3
                CO2_Emissions_from_BDN = ((ele.me_fo_cons - ME_based_on_BDN) * vlsfo);
                ele.co2_emission_BDN = CO2_Emissions_from_BDN.toFixed(2);//------4

            } else if (ele.fuel_use == 2) {
                let Ulsfo = 3.188;
                let welltowake = 3.734;
                Well_To_Wake_co2_emission = (welltowake * ele.me_fo_cons)
                ele.Well_To_Wake_co2_emission = (Well_To_Wake_co2_emission).toFixed(2);
                CO2_Emissions_Calculated = (Ulsfo * ele.me_fo_cons);
                ele.co2_emission = CO2_Emissions_Calculated.toFixed(2);    //--------1
                CO2_Emissions_CV_from_Seatrials = ((ele.me_fo_cons - ME_based_on_cv) * Ulsfo);
                ele.co2_emission_seatrails = CO2_Emissions_CV_from_Seatrials.toFixed(2); //------2
                Clean_hull_conditons = ((ele.me_fo_cons - ME_based_fuel_in_use) * Ulsfo);
                ele.Clean_hull_conditons = Clean_hull_conditons.toFixed(2); //---------3
                CO2_Emissions_from_BDN = ((ele.me_fo_cons - ME_based_on_BDN) * Ulsfo);
                ele.co2_emission_BDN = CO2_Emissions_from_BDN.toFixed(2);//------4
            } else if (ele.fuel_use == 3) {
                let Mgo = 3.206;
                let welltowake = 3.782;
                Well_To_Wake_co2_emission = (welltowake * ele.me_fo_cons)
                ele.Well_To_Wake_co2_emission = (Well_To_Wake_co2_emission).toFixed(2);
                CO2_Emissions_Calculated = (Mgo * ele.me_fo_cons);
                ele.co2_emission = CO2_Emissions_Calculated.toFixed(2);    //--------1
                CO2_Emissions_CV_from_Seatrials = ((ele.me_fo_cons - ME_based_on_cv) * Mgo);
                ele.co2_emission_seatrails = CO2_Emissions_CV_from_Seatrials.toFixed(2); //------2
                Clean_hull_conditons = ((ele.me_fo_cons - ME_based_fuel_in_use) * Mgo);
                ele.Clean_hull_conditons = Clean_hull_conditons.toFixed(2); //---------3
                CO2_Emissions_from_BDN = ((ele.me_fo_cons - ME_based_on_BDN) * Mgo);
                ele.co2_emission_BDN = CO2_Emissions_from_BDN.toFixed(2);//------4
            } else if (ele.fuel_use == 4) {
                let Lng = 2.750;
                let welltowake = 3.28;
                Well_To_Wake_co2_emission = (welltowake * ele.me_fo_cons)
                ele.Well_To_Wake_co2_emission = (Well_To_Wake_co2_emission).toFixed(2);
                CO2_Emissions_Calculated = (Lng * ele.me_fo_cons);
                ele.co2_emission = CO2_Emissions_Calculated.toFixed(2);    //--------1
                CO2_Emissions_CV_from_Seatrials = ((ele.me_fo_cons - ME_based_on_cv) * Lng);
                ele.co2_emission_seatrails = CO2_Emissions_CV_from_Seatrials.toFixed(2); //------2
                Clean_hull_conditons = ((ele.me_fo_cons - ME_based_fuel_in_use) * Lng);
                ele.Clean_hull_conditons = Clean_hull_conditons.toFixed(2); //---------3
                CO2_Emissions_from_BDN = ((ele.me_fo_cons - ME_based_on_BDN) * Lng);
                ele.co2_emission_BDN = CO2_Emissions_from_BDN.toFixed(2);//------4
            }

            ME_Well_To_Wake_CO2_Emissions_Calculated = ME_Well_To_Wake_CO2_Emissions_Calculated + Well_To_Wake_co2_emission;
            ME_CO2_Emissions_Calculated = ME_CO2_Emissions_Calculated + CO2_Emissions_Calculated;
            ME_CO2_Emissions_CV_from_Seatrials = ME_CO2_Emissions_CV_from_Seatrials + ele.co2_emission_seatrails;
            ME_Clean_hull_conditons = ME_Clean_hull_conditons + Clean_hull_conditons;
            ME_CO2_Emissions_from_BDN = ME_CO2_Emissions_from_BDN + CO2_Emissions_from_BDN;

        });
        let AE_FO_consumption_kg_h = 0;              //internal formula
        let AE_based_on_cv = 0;                     //internal formula
        let AE_based_fuel_in_use = 0;              //internal formula
        let AE_based_on_BDN = 0;                  //internal formula
        let axililaryengine = config2;
        axililaryengine.forEach((ele, index) => {
            let Actual_Load_MCR = ((ele.actual_load / ele.mcr) * 100);
            ele.Actual_Load_MCR = Actual_Load_MCR.toFixed(2);
            let start = new Date(ele.start);
            let end = new Date(ele.end);
            total = ((end - start) / 36e5)
            ele.total = total.toFixed(2); //--result
            let AE_FO_CTR_Start = parseFloat(ele.AE_FO_CTR_Start);
            let AE_FO_CTR_End = parseFloat(ele.AE_FO_CTR_End);
            AE_Fo_consumption = (AE_FO_CTR_End - AE_FO_CTR_Start);
            ele.AE_Fo_consumption = AE_Fo_consumption.toFixed(2);

            AE_FO_consumption_kg_h = (ele.mcr * ele.fO_Con_100) / 1000;///internal formula
            AE_based_on_cv = (((ele.actual_load * ele.fO_Con_100) / 1000000) * total).toFixed(2);  //internal formula
            AE_based_fuel_in_use = ((ele.Calorific_Value_from_Seatrails / ele.Actual_Calorific_Value) * AE_based_on_cv).toFixed(2);  //internal formula
            AE_based_on_BDN = ((ele.Actual_Calorific_Value / ele.BDN) * ele.AE_Fo_consumption).toFixed(2); ////internal formula
            let Well_To_Wake_co2_emission = 0;
            let CO2_Emissions_Calculated = 0;
            let CO2_Emissions_CV_from_Seatrials = 0;
            let Clean_hull_conditons = 0;
            let CO2_Emissions_from_BDN = 0;
            if (ele.fuel_use == 1) {
                let vlsfo = 3.188;
                let welltowake = 3.734;
                Well_To_Wake_co2_emission = (welltowake * ele.AE_Fo_consumption);
                ele.Well_To_Wake_co2_emission = (Well_To_Wake_co2_emission).toFixed(2);
                CO2_Emissions_Calculated = (vlsfo * ele.AE_Fo_consumption);
                ele.co2_emission = CO2_Emissions_Calculated.toFixed(2);//--------1
                CO2_Emissions_CV_from_Seatrials = ((ele.AE_Fo_consumption - AE_based_on_cv) * vlsfo);
                ele.co2_emission_seatrails = CO2_Emissions_CV_from_Seatrials.toFixed(2); //------2
                Clean_hull_conditons = ((ele.AE_Fo_consumption - AE_based_fuel_in_use) * vlsfo);
                ele.Clean_hull_conditons = Clean_hull_conditons.toFixed(2);//-------3
                CO2_Emissions_from_BDN = ((ele.AE_Fo_consumption - AE_based_on_BDN) * vlsfo);
                ele.co2_emission_BDN = CO2_Emissions_from_BDN.toFixed(2);//------4
            } else if (ele.fuel_use == 2) {
                let Ulsfo = 3.188;
                let welltowake = 3.734;
                Well_To_Wake_co2_emission = (welltowake * ele.AE_Fo_consumption);
                ele.Well_To_Wake_co2_emission = (Well_To_Wake_co2_emission).toFixed(2);
                CO2_Emissions_Calculated = (Ulsfo * ele.AE_Fo_consumption);
                ele.co2_emission = CO2_Emissions_Calculated.toFixed(2);  //------1
                CO2_Emissions_CV_from_Seatrials = ((ele.AE_Fo_consumption - AE_based_on_cv) * Ulsfo);
                ele.co2_emission_seatrails = CO2_Emissions_CV_from_Seatrials.toFixed(2); //------2
                Clean_hull_conditons = ((ele.AE_Fo_consumption - AE_based_fuel_in_use) * Ulsfo);
                ele.Clean_hull_conditons = Clean_hull_conditons.toFixed(2);//-------3
                CO2_Emissions_from_BDN = ((ele.AE_Fo_consumption - AE_based_on_BDN) * Ulsfo);
                ele.co2_emission_BDN = CO2_Emissions_from_BDN.toFixed(2);//------4
            } else if (ele.fuel_use == 3) {
                let Mgo = 3.206;
                let welltowake = 3.782;
                Well_To_Wake_co2_emission = (welltowake * ele.AE_Fo_consumption);
                ele.Well_To_Wake_co2_emission = (Well_To_Wake_co2_emission).toFixed(2);
                CO2_Emissions_Calculated = (Mgo * ele.AE_Fo_consumption);
                ele.co2_emission = CO2_Emissions_Calculated.toFixed(2);    //------1
                CO2_Emissions_CV_from_Seatrials = ((ele.AE_Fo_consumption - AE_based_on_cv) * Mgo);
                ele.co2_emission_seatrails = CO2_Emissions_CV_from_Seatrials.toFixed(2); //------2
                Clean_hull_conditons = ((ele.AE_Fo_consumption - AE_based_fuel_in_use) * Mgo);
                ele.Clean_hull_conditons = Clean_hull_conditons.toFixed(2);//-------3
                CO2_Emissions_from_BDN = ((ele.AE_Fo_consumption - AE_based_on_BDN) * Mgo);
                ele.co2_emission_BDN = CO2_Emissions_from_BDN.toFixed(2);//------4
            } else if (ele.fuel_use == 4) {
                let Lng = 2.750;
                let welltowake = 3.28;
                Well_To_Wake_co2_emission = (welltowake * ele.AE_Fo_consumption);
                ele.Well_To_Wake_co2_emission = (Well_To_Wake_co2_emission).toFixed(2);
                CO2_Emissions_Calculated = (Lng * ele.AE_Fo_consumption);
                ele.co2_emission = CO2_Emissions_Calculated.toFixed(2);    //------1
                CO2_Emissions_CV_from_Seatrials = ((ele.AE_Fo_consumption - AE_based_on_cv) * Lng);
                ele.co2_emission_seatrails = CO2_Emissions_CV_from_Seatrials.toFixed(2); //------2
                Clean_hull_conditons = ((ele.AE_Fo_consumption - AE_based_fuel_in_use) * Lng);
                ele.Clean_hull_conditons = Clean_hull_conditons.toFixed(2);//-------3
                CO2_Emissions_from_BDN = ((ele.AE_Fo_consumption - AE_based_on_BDN) * Lng);
                ele.co2_emission_BDN = CO2_Emissions_from_BDN.toFixed(2);//------4
            }
            AE_Well_To_Wake_CO2_Emissions_Calculated = AE_Well_To_Wake_CO2_Emissions_Calculated + Well_To_Wake_co2_emission;
            AE_CO2_Emissions_Calculated = AE_CO2_Emissions_Calculated + CO2_Emissions_Calculated;
            AE_CO2_Emissions_CV_from_Seatrials = AE_CO2_Emissions_CV_from_Seatrials + ele.co2_emission_seatrails;
            AE_Clean_hull_conditons = AE_Clean_hull_conditons + Clean_hull_conditons;
            AE_CO2_Emissions_from_BDN = AE_CO2_Emissions_from_BDN + CO2_Emissions_from_BDN;
        });

        let Total_Well_To_Wake_CO2_Emissions_Calculated = (ME_Well_To_Wake_CO2_Emissions_Calculated + AE_Well_To_Wake_CO2_Emissions_Calculated).toFixed(2);
        let Total_CO2_Emissions_Calculated = (ME_CO2_Emissions_Calculated + AE_CO2_Emissions_Calculated).toFixed(2); ///total result of CO2_Emissions_Calculated
        let Total_CO2_Emissions_CV_from_Seatrials = ((parseFloat(ME_CO2_Emissions_CV_from_Seatrials + AE_CO2_Emissions_CV_from_Seatrials) / Total_CO2_Emissions_Calculated) * 100).toFixed(0);  ///total result of CO2_Emissions_CV_from_Seatrials
        let Total_Clean_hull_conditons = (((ME_Clean_hull_conditons + AE_Clean_hull_conditons) / Total_CO2_Emissions_Calculated) * 100).toFixed(0);//toatl Clean hull conditons
        let Total_CO2_Emissions_from_BDN = (((ME_CO2_Emissions_from_BDN + AE_CO2_Emissions_from_BDN) / Total_CO2_Emissions_Calculated) * 100).toFixed(0);  ///total result of CO2_Emissions_from_BDN
        return {
            mainengine,
            axililaryengine,
            Total_Well_To_Wake_CO2_Emissions_Calculated,
            Total_CO2_Emissions_Calculated,
            Total_CO2_Emissions_CV_from_Seatrials,
            Total_Clean_hull_conditons,
            Total_CO2_Emissions_from_BDN

        }
    }

}

